import React, { useEffect } from "react";
import { DonContext } from "../../pages/StandardDon";
import { Backdrop, Box, Button, Typography, CircularProgress } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { Context } from "../../App";


export default function DonInfoSection({ don, index }) {
    const navigate = useNavigate();
    // const { isConnected } = React.useContext(Context);
    const [load, setLoad] = React.useState(true);
    const [donData, setDonData] = React.useState(don);
    const [egliseData, setEgliseData] = React.useState(null);
    
    const total = React.useMemo(() => {
        return don.dime + don.offrande_globale + 
        [...don.offrande_spe_feam, ...don.offrande_spe_eglise].reduce((acc, curr) => acc + curr.montant, 0);
    }, [don]);

    useEffect(() => {
        const query = new URLSearchParams({_id: don._id}).toString();
        fetch(process.env.REACT_APP_ESDRAS_API_URL.concat('/don/populate?', query), { method: 'GET', 
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || localStorage.getItem('anonUserId') || ''}`
            }
        }).then(async(res) => {
            const token = res.headers.get('x-auth-token');
            if (token) localStorage.setItem('token', token);
            if(!res.ok) {
                const error = await res.text();
                throw new Error(`API error: ${res.status} - ${error}`);
            }
            return res.json();
        }).then((data) => {
            setDonData(data[0]);
            console.log("Updated don data:", data);
        }).catch((err) => {
            console.error("Error populating don data:", err);
        });
        
        // Fetch eglise data
        const egliseQuery = new URLSearchParams({number: don.eglise}).toString();
        fetch(process.env.REACT_APP_THYBA_API_URL.concat('/public/eglises/by?', egliseQuery), { method: 'GET'})
        .then(async(res) => {
            if(!res.ok) {
                const error = await res.text();
                throw new Error(`API error: ${res.status} - ${error}`);
            }
            return res.json();
        }).then((data) => {
            setEgliseData(data[0]);
        }).catch((err) => {
            console.error("Error fetching eglise data:", err);
        }).finally(() => { setLoad(false); });
    }, [don]);

    
    return <Box display={"flex"} flexDirection="column" gap={2} sx={{ mt: 2, mb:4 }}>
        {don.dime > 0 && <Typography variant="body1">Dime: {don.dime} €</Typography>}
        {don.offrande_globale > 0 && <Typography variant="body1">Offrande globale: {don.offrande_globale} €</Typography>}
        {don.offrande_spe_feam.length > 0 && <Typography variant="body1">Offrandes fédérales: {don.offrande_spe_feam.map((off, index) => `${off.libelle}: ${off.montant} €`).join(', ')}</Typography>}
        {don.offrande_spe_eglise.length > 0 && <Typography variant="body1">Offrandes locales: {don.offrande_spe_eglise.map((off, index) => `${off.libelle}: ${off.montant} €`).join(', ')}</Typography>}
        <Typography variant="body1">Église bénéficiaire: {egliseData?.nom}</Typography>
        <Typography variant="body1" style={{textTransform:'capitalize'}}>Donateur: {donData.isAnonyme ? 'Anonyme' : `${donData.donateur?.genre} ${donData.donateur?.nom} ${donData.donateur?.prenom1} ${donData.donateur?.prenom2}`}</Typography>
        <Typography variant="body1">Type de don: {donData.recurrent ? 'Récurrent' : 'Ponctuel'}</Typography>

        <Typography variant="h6" color='primary' sx={{marginBlock:2, marginLeft:5}}>SOUS TOTAL DON {index+1} : {total?.toFixed(2)}€</Typography>
        <Backdrop open={load}><CircularProgress/></Backdrop>
      
    </Box>
}